import React, { useEffect } from 'react';

import { OnboardingChecklistItem } from 'app/helpers/gamification/challengeDomain';

import {
  trackOnboardingChecklistViewed,
  trackOnboardingChecklistItemClicked,
} from './trackOnboardingChecklistEvents';
import * as S from './OnboardingChecklist.styles';

type OnboardingChecklistProps = {
  items: OnboardingChecklistItem[];
  completedCount: number;
  totalCount: number;
  loading: boolean;
  onItemSelect: (item: OnboardingChecklistItem) => void;
};

const OnboardingChecklist: React.FC<OnboardingChecklistProps> = ({
  items,
  completedCount,
  totalCount,
  loading,
  onItemSelect,
}) => {
  useEffect(() => {
    if (loading) {
      return;
    }
    trackOnboardingChecklistViewed(totalCount, completedCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if (loading) {
    return <S.Loading role="status">Carregando seus primeiros passos…</S.Loading>;
  }

  const progressPercentage = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <S.Container>
      <S.Progress>
        <S.ProgressLabel id="onboarding-checklist-progress-label">{`${completedCount} de ${totalCount} concluídos`}</S.ProgressLabel>
        <S.ProgressTrack
          role="progressbar"
          aria-labelledby="onboarding-checklist-progress-label"
          aria-valuenow={completedCount}
          aria-valuemin={0}
          aria-valuemax={totalCount}
        >
          <S.ProgressFill $percentage={progressPercentage} />
        </S.ProgressTrack>
      </S.Progress>

      <S.List>
        {items.map(item => (
          <S.Item
            key={item.id}
            type="button"
            $done={item.isDone}
            aria-disabled={item.isDone}
            onClick={() => {
              if (item.isDone) {
                return;
              }
              trackOnboardingChecklistItemClicked(item.name, item.event);
              onItemSelect(item);
            }}
          >
            <S.ItemName $done={item.isDone}>{item.name}</S.ItemName>
            {item.isDone ? (
              <S.ItemDoneBadge>Concluído</S.ItemDoneBadge>
            ) : item.points ? (
              <S.ItemPoints>{`+ ${item.points} XP`}</S.ItemPoints>
            ) : null}
          </S.Item>
        ))}
      </S.List>
    </S.Container>
  );
};

export default OnboardingChecklist;
